<template>
  <el-table :row-style="tableRowStyle" :header-cell-style="header_cell_style" :data="data" cell-class-name="cellStyle"
    :scrollbar-always-on="true" scrollbar-tabindex="4">
    <template #empty>
      <div class="empty">暂无数据</div>
    </template>
    <el-table-column style="background-color: red;" v-for="item in show_table_config" :key="item.key"
      :show-overflow-tooltip="Boolean(item.nowarp)"
      :width="item.width ? item.width : Boolean(item.nowarp) ? '150px' : ''" :fixed="item.fixed ? item.fixed : false">
      <template #header>
        {{ !item.header ? item.label : '' }}
        <div class="header_box center" v-if="item.header">
          <slot :name="'h_' + item.key" :data="item"></slot>
        </div>
      </template>
      <template v-slot="{ row,$index }">
        <div :class="['center']" v-if="item.type === 'slot'" @click="getTableSlotClick(item,row)">
          <slot :name="item.key" :row="row" :$index="$index"></slot>
        </div>
        <div :class="[Boolean(item.nowarp) ? 'nowarp' : '','center']" v-else-if="item.key.indexOf(',') !== -1"
          v-html="createMontageContent(row,item)"></div>
        <div :class="['center']" v-else-if="item.type === 'img'"> <el-image class="show_image" :src="row[item.key]"
            fit="cover" /> </div>
        <div :class="['center']" v-else-if="item.type === 'switch'">
          <el-switch v-model="row[item.key]" :active-value="item.activeValue || 1"
            :inactive-value="item.inactiveValue || 0" :disabled="item.disabled || false" />
        </div>
        <div :class="['center']" v-else-if="item.type === 'text' && item.tooltip">
          <el-tooltip effect="dark" placement="top-start" width="320px">
            <template #content>
              <div class="tooltip_text">{{ row[item.key] }}</div>
            </template>
            <div class="text_overflow" v-if="row[item.key].length > 60">{{ row[item.key].substring(0,60) }}</div>
          </el-tooltip>
          <div class="text_overflow" v-if="row[item.key].length <= 60">{{ row[item.key] }}</div>
        </div>
        <div :class="[Boolean(item.nowarp) ? 'nowarp' : '','center',item.tooltip ? 'text_tooltip' : '']"
          :style="{'--text':row[item.key],'--c':'red'}" v-else v-html="createShowContent(item,getShowText(item,row))">
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { getDateformat } from "@/util/getDate.js";
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    table_config: Array,
    record_config: {
      type: Object,
      default: () => {
        return {
          is_record: true,
          key: "id",
        };
      },
    },
  },
  data() {
    return {
      header_cell_style: {
        textAlign: "center",
        backgroundColor: "#F7F8FA",
        height: "60px",
        fontWeight: 400,
        fontSize: "14px",
        color: "#333333",
      },
      already_click_key_hash: {},
    };
  },
  computed: {
    show_table_config() {
      const seenTypes = {};
      return this.table_config.filter((item) => {
        if (!seenTypes[item.key]) {
          seenTypes[item.key] = true;
          return true;
        }
        return false;
      });
    },
    _record_config() {
      let obj = {
        is_record: this.record_config.is_record,
        key: this.record_config.key || "id",
      };
      return obj;
    },
  },
  methods: {
    createMontageContent(table_row, row_config) {
      let h = ``;
      if (row_config.key) {
        let keys = row_config.key.split(",");
        keys.forEach((item, index) => {
          h += this.createShowContent(
            row_config,
            this.getShowText(item, table_row)
          );
          if (index !== keys.length - 1) {
            h += row_config.join;
          }
        });
      }
      return h;
    },
    createShowContent(row_config, data) {
      let h = ``;
      if (row_config.type === "text") return (h += `<div>${data}</div>`);
      if (row_config.type === "img")
        return (h += ` <img style="width: 100px; height: 100px" :src="${data}" fit="cover" />`);
      if (row_config.type === "time")
        return (h += `<span>${getDateformat(data)}</span>`);
      return "";
    },
    getShowText(row_config, table_row) {
      let c = row_config;
      if (typeof row_config == "string") c = { key: row_config };
      if (table_row[c.key]) return table_row[c.key];
      if (c.none) return row_config.none;
      return "--";
    },
    getTableSlotClick(item, row) {
      if (item.key == "cz" && this._record_config.is_record) {
        this.already_click_key_hash = {};
        this.already_click_key_hash[row[this._record_config.key]] = true;
      }
    },
    tableRowStyle({ row }) {
      if (this.already_click_key_hash[row[this._record_config.key]]) {
        return { backgroundColor: "#f3f6f9" };
      }
      return {};
    },
  },
};
</script>

<style lang="less" scoped>
.el-table {
  width: 100%;
  & :deep(.cellStyle) {
    & :deep(.cell) {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .show_image {
    width: 60px;
  }
  .nowarp {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // justify-content: flex-start;
  }
}
.header_box {
  width: 100%;
  height: 100%;
}
.tooltip_text {
  width: 320px;
  white-space: pre-wrap;
}
/deep/ .text_overflow {
  width: 320px;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.el-table /deep/ .is-vertical {
  width: 10px !important;
}
.el-table /deep/ .is-horizontal {
  height: 10px !important;
}
</style>
